import { __pick, __compact, __partialRight } from './';
import __ from 'lodash';

/**
 * انتخاب کردن فیلد هایی از آبجکت های داخل یک آرایه بزرگ
 * @param array - آرایه ای از آبجکت ها
 * @param fields - فیلد ها
 * @example <caption>برای مثال پیک کردن فیلد های آ و سی</caption>
 * pickFields([{ a: 1, b: '2', c: 3 }, { a: 3, b: '5', c: 4 }], "a,c"]);
 * @returns {Array} [{ a: 1, c: 3 }, { a: 3, c: 4 }]
 */
export const pickFields = (array, fields = '') =>
  array.map(
    __partialRight(
      __pick,
      __compact(fields.split(',').map((f) => (f || '').trim()))
    )
  );

/**
 * انتخاب کردن یک فیلد از آبجکت های داخل یک آرایه بزرگ
 * @param array - آرایه ای از آبجکت ها
 * @param field - فیلد
 * @example <caption>برای مثال پیک کردن فیلد سی</caption>
 * pickFields([{ a: 1, b: '2', c: 3 }, { a: 3, b: '5', c: 4 }], "c"]);
 * @returns {Array} [3, 4]
 */
export const pickField = (array, field = '') =>
  array.map(__partialRight(__pick, __compact(field)));
